/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LineErrorResponse } from './';
import {
    LineErrorResponseFromJSON,
    LineErrorResponseFromJSONTyped,
    LineErrorResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface MigrateCompanyManagerProcessResponse
 */
export interface MigrateCompanyManagerProcessResponse {
    /**
     * 
     * @type {LineErrorResponse}
     * @memberof MigrateCompanyManagerProcessResponse
     */
    error?: LineErrorResponse;
}

/**
 * Check if a given object implements the MigrateCompanyManagerProcessResponse interface.
 */
export function instanceOfMigrateCompanyManagerProcessResponse(value: object): value is MigrateCompanyManagerProcessResponse {
    return true;
}

export function MigrateCompanyManagerProcessResponseFromJSON(json: any): MigrateCompanyManagerProcessResponse {
    return MigrateCompanyManagerProcessResponseFromJSONTyped(json, false);
}

export function MigrateCompanyManagerProcessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrateCompanyManagerProcessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : LineErrorResponseFromJSON(json['error']),
    };
}

export function MigrateCompanyManagerProcessResponseToJSON(value?: MigrateCompanyManagerProcessResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'error': LineErrorResponseToJSON(value['error']),
    };
}

